import { DEBUG, PATH } from '../constants';

const base = PATH;
const debug = DEBUG;



export async function getGamesByUser(idUser) {
    const token = localStorage.getItem("authToken");
    try {
        const response = await fetch(`${base}partenaire/games/${idUser}`, {
        method: 'GET',
        headers: { 'Authorization': `Bearer ${token}` },
        });
        return await response.json();
    } catch (error) {
        if (debug) console.error('Erreur getGamesByUser', error);
        throw error;
    }
}

export async function getUsersByGame(idGame) {
    const token = localStorage.getItem("authToken");
    try {
        const response = await fetch(`${base}partenaire/users/${idGame}`, {
        method: 'GET',
        headers: { 'Authorization': `Bearer ${token}` },
        });
        return await response.json();
    } catch (error) {
        if (debug) console.error('Erreur getUsersByGame', error);
        throw error;
    }
}

export async function assignGameToUser(idUser, idGame) {
    const token = localStorage.getItem("authToken");
    try {
        const response = await fetch(`${base}partenaire/assign`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({ id_user: idUser, id_game: idGame }),
        });
        return await response.json();
    } catch (error) {
        if (debug) console.error('Erreur assignGameToUser', error);
        throw error;
    }
}

export async function revokeGameFromUser(idUser, idGame) {
    const token = localStorage.getItem("authToken");
    try {
        const response = await fetch(`${base}partenaire/revoke`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({ id_user: idUser, id_game: idGame }),
        });
        return await response.json();
    } catch (error) {
        if (debug) console.error('Erreur revokeGameFromUser', error);
        throw error;
    }
}

export async function checkIfAssigned(idUser, idGame) {
    const token = localStorage.getItem("authToken");
    try {
        const response = await fetch(`${base}partenaire/check?id_user=${idUser}&id_game=${idGame}`, {
        method: 'GET',
        headers: { 'Authorization': `Bearer ${token}` },
        });
        return await response.json();
    } catch (error) {
        if (debug) console.error('Erreur checkIfAssigned', error);
        throw error;
    }
}
